import { BillState } from '@app/models/interfaces/bill-state';

export const billState: BillState = {
  bills: [],
  selected: null,
  paginator: null,
  total: null
};
